export const CHAT_OUTBOX_QUEUED_EVENT = "mivo:chat-outbox-queued";
export const CHAT_MESSAGE_SENT_EVENT = "mivo:chat-message-sent";
export const CHAT_OUTBOX_FLUSHED_EVENT = "mivo:chat-outbox-flushed";
export const CHAT_CONVERSATION_CREATED_EVENT = "mivo:chat-conversation-created";

export type ChatMessageSentDetail = {
  outboxId: string;
  conversationId: string;
  message: {
    id: string;
    senderId: string;
    content: string;
    createdAt: string;
    conversationId?: string;
  };
};

export function emitChatMessageSent(detail: ChatMessageSentDetail): void {
  window.dispatchEvent(new CustomEvent(CHAT_MESSAGE_SENT_EVENT, { detail }));
}

export function emitChatConversationCreated(detail: {
  tempId: string;
  conversation: Record<string, unknown>;
}): void {
  window.dispatchEvent(new CustomEvent(CHAT_CONVERSATION_CREATED_EVENT, { detail }));
}

export function emitChatOutboxQueued(outboxId: string): void {
  window.dispatchEvent(new CustomEvent(CHAT_OUTBOX_QUEUED_EVENT, { detail: { outboxId } }));
}

export function emitChatOutboxFlushed(conversationIds: string[]): void {
  window.dispatchEvent(new CustomEvent(CHAT_OUTBOX_FLUSHED_EVENT, { detail: { conversationIds } }));
}
